/**
 * KEYBOARD — глобальные keyboard shortcuts + закрытие модалов.
 *
 * Phase 5 sub-extract (Sprint 15 C.3 part 1, 2026-05-10).
 * Извлечено из public/js/app.js.
 *
 * Шорткаты:
 *   • Escape — закрыть открытые модалы (работает и в input-полях)
 *   • Ctrl/Cmd+N — новая смета
 *   • Ctrl/Cmd+P — печать сметы
 *   • Delete — удалить выбранные услуги (только когда не в input)
 *
 * В input-полях разрешены стандартные команды редактирования
 * (Ctrl+A/Z/Y/X/C/V) и блокируются только кастомные шорткаты.
 *
 * Подключение из entry.js через `attachKeyboard(ProfessionalQuoteCalculator)`.
 *
 * @module app/keyboard
 */

'use strict';

export function attachKeyboard(ClassRef) {
    Object.assign(ClassRef.prototype, {
        bindKeyboardShortcuts() {
            document.addEventListener('keydown', (e) => {
                const isInputField = e.target.tagName === 'INPUT' ||
                                    e.target.tagName === 'TEXTAREA' ||
                                    e.target.contentEditable === 'true';

                // В полях ввода разрешаем стандартные команды редактирования
                if (isInputField) {
                    // Разрешаем стандартные команды: Ctrl+A, Ctrl+Z, Ctrl+Y, Ctrl+X, Ctrl+C, Ctrl+V
                    const isEditCommand = (e.ctrlKey || e.metaKey) &&
                        ['a', 'z', 'y', 'x', 'c', 'v'].includes(e.key.toLowerCase());

                    // Разрешаем Escape для закрытия модалов даже в полях ввода
                    if (e.key === 'Escape') {
                        this.closeAllModals();
                        return;
                    }

                    // Блокируем только наши кастомные шорткаты в полях ввода
                    if (!isEditCommand) {
                        if ((e.ctrlKey || e.metaKey) && ['n', 'p'].includes(e.key.toLowerCase())) {
                            // Сохраняем наши кастомные шорткаты (удалено 's' и 'o')
                        } else {
                            // Для всех остальных клавиш - разрешаем нативное поведение
                            return;
                        }
                    } else {
                        // Разрешаем стандартные команды редактирования
                        return;
                    }
                }

                // Escape - close modals
                if (e.key === 'Escape') {
                    this.closeAllModals();
                }

                // Ctrl+S отключен (пользователь использует для других целей)
                // Используйте кнопку "Сохранить смету" вместо этого

                // Ctrl+O отключен (пользователь использует для других целей)
                // Используйте кнопку "Загрузить смету" вместо этого

                // Ctrl+N - new quote
                if ((e.ctrlKey || e.metaKey) && e.key === 'n') {
                    e.preventDefault();
                    this.reset();
                }

                // Ctrl+P - print
                if ((e.ctrlKey || e.metaKey) && e.key === 'p') {
                    e.preventDefault();
                    this.print();
                }

                // Delete - delete selected services (only if not in input)
                if (e.key === 'Delete' && this.state.selectedServices.size > 0 && !isInputField) {
                    e.preventDefault();
                    this.deleteSelected();
                }
            });
        },

        closeAllModals() {
            document.querySelectorAll('.modal').forEach(modal => {
                modal.classList.remove('show');
            });
        }
    });
}
